import api from '../token';

export const AlterProduto = async (dados) => {
  try {
    const response = await api.post('/alterProduto', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};


